module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAH0lEQVQoU2NMS0t7yMDAIMeAHzxiJKAALk0DhcPJjQDtLQlD3yZIMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/1.png
// module id = TnaX
// module chunks = 29